import React from 'react';
import { Card, CardText, CardBody, CardTitle } from 'reactstrap';
import Log from './Log';

export default class LogList extends React.PureComponent {
  getLogs() {
    return this.props.logs || [];
  }

  render() {
    return (<div>
      {this.props.heading ?
        <h2>{this.props.heading}</h2>
        : null}
      <ul className="log-list">
        {this.getLogs().length === 0 ?
          <li className="log-list-item">
            <Log
              color
              time=""
              heading="success"
              message="No conversion alerts to display."
            />
          </li>
            : null }
        {this.getLogs().map((log, index) =>
            (<li key={`cl${index}`} className="log-list-item">
              <Log
                color={this.props.color}
                time={log.updated_at}
                heading={log.heading}
                message={log.message}
              />
            </li>),
          )}
      </ul>
    </div>);
  }
}
